import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { Maintenance } from "../../../models/maintenance";
import { IResource } from "../../../utils/interfaces/resource.interface";
import MaintenanceRepository from "../../../repositories/maintenance-repository";
import { MaintenanceDataList } from "../list/interface";

export const useGetMaintenance = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<MaintenanceDataList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [detailData, setDetailData] = useState<Maintenance | null>(null);
  const [isOnFetchingDetailData, setIsOnFetchingDetailData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await MaintenanceRepository.all(params)
      .then((response: AxiosResponse<ICollection<MaintenanceDataList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadDetailData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingDetailData(true);

      await MaintenanceRepository.show(id, params)
        .then((response: AxiosResponse<IResource<Maintenance>>) => {
          setDetailData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingDetailData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadDetailData,
    isOnFetchingDetailData,
    detailData,
  };
};
